export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  account: (state) => state.account,
  balance: (state) => state.balance,
  walletAddress: (state) => {
    if (!state.account) return '';
    return state.account.individual_master_data.user_hw_wallet_address || '';
  },
  documents: (state) => state.account?.individual_documents,
  masterData: (state) => state.account?.individual_master_data,
  questionnaire: (state) => {
    try {
      return JSON.parse(state.account.individual_questionnaire.questionnaire);
    }
    catch {
      return null;
    }
  },
  video: (state) => state.account?.individual_video,
  hasIndividualWallet: (state) => {
    if (!state.account) {
      return false;
    }
    return !!state.account.individual_master_data.user_hw_wallet_address;
  },
};
